import React from "react"
import { 
    Flex,
    Text
 } from "@chakra-ui/react"

const SectionHeader = ({ title, description, ...props }) => {
    return (
        <Flex
            w='100%'
            flexDir={'column'}
            mb='20px'
            {...props}
        >
            <Text
                mb='2px'
                fontSize='1.1em'
                fontWeight='500'
            >
                {title}
            </Text>
            <Text fontSize='.9em'>
                {description}
            </Text>
        </Flex>
    )
}

export default SectionHeader